<template lang="pug">
b-modal#modal-widget-script(title='貼り付け用タグを取得')
  .callout.callout-info
    p 以下のタグをコピーしてwidgetを表示したいwebサイトの位置に貼り付けてください
  .row
    textarea.form-control(rows=5)
      | <div id="blogparts_{{$store.state.widget.token}}"></div><script type="text/javascript" charset="utf-8" src="{{$store.state.widget.url}}"></script>
</template>

<script>
import Vue from 'vue'

export default {
  methods: {
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
